import { h } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import {
	Box,
	Button,

	Grid,
	Paper,
	Stack,

	Typography,
} from "@mui/material";


import PickHome from "./PickHome";
import PersonnalCard from "../Common/PersonnalCard";
import ProspectDealCard from "../Common/ProspectDealCard";
import ProspectMeetingsCard from "../Common/ProspectMeetingsCard";




import EventsTimeLineCard from "../Common/EventsTimeLineCard";

import { AppContext } from "../../AppContext";

import { redThreadUser } from "../Common/redthread";

export default function DashboardProspect({ uid }) {
	const [state, setState] = useState({ ctx: undefined });

	const app = useContext(AppContext);
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/acq/", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							ctx: res.pld,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);



	if (state.ctx === undefined) return;
	useEffect(() => {

		redThreadUser(state, app, "acquéreur");

	}, [state]);
	return (

		<Grid container spacing={1}>
			<Grid item xs={12}>
				<Paper style="padding: 10px; height: 100%;">
					<Typography variant="h5">Bienvenue dans votre espace acquéreur</Typography>
				</Paper>
			</Grid>
			<Grid item xs={12} md={6}>
				<Stack spacing={1}>
					<PersonnalCard user={state.ctx} role="AC" />
					<ProspectMeetingsCard mtngs={state.ctx.mtgs} app={app} />
					<Paper style="padding: 10px; ">
						<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
							<Typography variant="h5">
								Vos annonces favorites
							</Typography>
							{state && state.ctx && state.ctx.deals && state.ctx.deals.length > 0 && <Button href="/search">Aller sur le moteur de recherche</Button>}

						</Box>
					</Paper>

					{state &&
						state.ctx &&
						state.ctx.deals &&
						state.ctx.deals.length > 0 &&
						state.ctx.deals.map((dl) => {

							return (
								<ProspectDealCard dl={dl} app={app} user_undone={state.ctx.user_undone || (state.ctx.user_undone.length == 0)} />
							);
						})}
					{
						state && state.ctx && state.ctx.deals && state.ctx.deals.length == 0 && (
							<Paper style="padding: 10px;">
								<Stack>
									<Typography variant="h5">
										Vous n'en avez pas, il faut aller sur le moteur de recherche pour trouver votre bonheur...
									</Typography>
									<Button href="/search">Aller sur le moteur de recherche</Button>
									<PickHome />
								</Stack >
							</Paper>
						)
					}
				</Stack >
			</Grid >
			<Grid item xs={12} md={6}>
				<EventsTimeLineCard events={state.ctx.events} />

			</Grid>
		</Grid >

	);
}
